import _ from 'lodash';
import jsonPath from 'jsonpath';
import { orderBy } from 'natural-orderby';

import book from 'content/book.json';
import AppState from 'app/state/AppState';

const {metadata, ...Book} = book;
let pages = _.keys(Book);

const bodyBounds = {
  first: _.findIndex(pages, entry => entry.includes('chapter')),
  last: _.findLastIndex(pages, entry => entry.includes('chapter')),
};

let frontMatter = pages.slice(0, bodyBounds.first);
let body = orderBy(pages.filter(entry => entry.includes('chapter')));
let backMatter = pages.slice(bodyBounds.last + 1);

pages = [...frontMatter, ...body, ...backMatter];

const Contents = {};

Contents.source = undefined;

Contents.get = path => {
  const book = Contents.source || Book;
  return _.get(book, jsonPath.stringify(path).replace(/^[$.]+/i, ''));
};

Contents.extract = (path, prop) => {
  const book = Contents.source || Book;
  path = _.dropRight(path);
  return _.get(book, `${jsonPath.stringify(path).slice(1)}.${prop}`);
};

const selectedIndex = () => _.indexOf(pages, AppState.selectedSection[1]);

Contents.hasNextSection = () =>
  selectedIndex(AppState.selectedSection) < pages.length - 1;

Contents.hasPreviousSection = () => 0 < selectedIndex(AppState.selectedSection);

Contents.nextSection = () => {
  if (Contents.hasNextSection()) {
    let path = pages[selectedIndex() + 1];
    path = path.includes('chapter') ? [path, 0] : [path];
    AppState.changeSectionItem(['$', ...path]);
  }
};

Contents.previousSection = () => {
  if (Contents.hasPreviousSection()) {
    let path = pages[selectedIndex() - 1];
    path = path.includes('chapter') ? [path, 0] : [path];
    AppState.changeSectionItem(['$', ...path]);
  }
};

export default Contents;



// WEBPACK FOOTER //
// ./src/app/api/contents.js